import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 page-enter">
      <SEO
        title="Terms of Service — Arbe Minimart"
        description="The terms governing your use of arbeminimart.com — Filipino online grocery and meat delivery in Oroquieta City, Misamis Occidental."
        path="/terms"
      />
      <div className="overline">Legal</div>
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1C2826] tracking-tighter">Terms of Service</h1>
      <p className="mt-2 text-sm text-[#738380]">Last updated: April 2026</p>

      <section className="mt-8 prose prose-sm max-w-none text-[#1C2826]">
        <p>By using arbeminimart.com, you agree to these Terms. If you do not agree, please do not use the site.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">1. The store</h2>
        <p>Arbe Minimart sells groceries, fresh meats, condiments and frozen products through our physical store in Oroquieta City, Misamis Occidental, and through this online site. Product photos are for reference only — actual cuts, weight and packaging may vary.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">2. Account</h2>
        <p>You must register with a valid email address and mobile number to place an order. You are responsible for keeping your password secret. Notify us right away if you suspect unauthorized access to your account.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">3. Orders &amp; pricing</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>All prices are in Philippine Peso (₱) and inclusive of applicable VAT.</li>
          <li>Stock is limited; if an item is out of stock after your order is placed, we will contact you to refund or substitute.</li>
          <li>Delivery for groceries, meats, frozen products and condiments is FREE for orders ≥ ₱1,000; below that a flat ₱20 delivery fee applies.</li>
          <li>Sunjin Feeds delivery is ₱10 per full sack. Orders containing only half-sack, per-kilo or retail-pack Sunjin items have a flat ₱20 delivery fee.</li>
          <li>Service area: Oroquieta City, Misamis Occidental. Calamba and other locations coming soon — may be accepted on request.</li>
        </ul>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">4. Payment</h2>
        <p>We accept GCash, Maya, Bank Transfer, PayPal and Cash on Delivery. For online payments you must upload a clear screenshot of your transfer; orders are confirmed once payment is verified.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">5. Delivery</h2>
        <p>Each order is given a 4-digit delivery code that the driver must verify with you at the door. This protects you from impersonators. Orders are typically delivered the same day; we will message you if there is a delay.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">6. Returns &amp; refunds</h2>
        <p>If a fresh product is spoiled, damaged on arrival, or noticeably under-weighed, contact us within 24 hours with a photo. We will refund or replace at our discretion. Sealed packaged goods cannot be returned once opened.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">7. Acceptable use</h2>
        <p>You agree not to use this site to break the law, disrupt our service, or scrape data without permission. We may suspend accounts that are used fraudulently.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">8. Intellectual property</h2>
        <p>All branding, photos and text on this site belong to Arbe Minimart unless otherwise credited.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">9. Limitation of liability</h2>
        <p>Our total liability for any claim related to an order is limited to the amount you paid for that order. We are not liable for indirect or consequential losses.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">10. Governing law</h2>
        <p>These Terms are governed by the laws of the Republic of the Philippines. Any dispute will be resolved in the proper courts of Misamis Occidental.</p>

        <h2 className="font-heading text-xl font-bold mt-8 mb-2">11. Contact</h2>
        <p>Questions? Reach us at <a href="tel:079202971717" className="text-[#2F5233] underline">079202971717</a> / <a href="tel:09202799298" className="text-[#2F5233] underline">09202799298</a>.</p>
      </section>

      <div className="mt-10 text-sm">
        See also: <Link to="/privacy" className="text-[#2F5233] underline font-semibold">Privacy Policy</Link>
      </div>
    </div>
  );
}
